export const SET_SEAT_TABLE_PARAMETERS = 'SET_SEAT_TABLE_PARAMETERS'
export const setSeatTableParameters = (payload) => ({
  type: SET_SEAT_TABLE_PARAMETERS,
  payload,
})

export const GET_SEAT_BRAND_RETAILERS_BULK_GET =
  'GET_SEAT_BRAND_RETAILERS_BULK_GET'
export const GET_SEAT_BRAND_RETAILERS_BULK_GET_FULFILLED =
  'GET_SEAT_BRAND_RETAILERS_BULK_GET_FULFILLED'
export const GET_SEAT_BRAND_RETAILERS_BULK_GET_REJECTED =
  'GET_SEAT_BRAND_RETAILERS_BULK_GET_REJECTED'
export const getSeatBrandRetailersBulkGet = (payload) => ({
  type: GET_SEAT_BRAND_RETAILERS_BULK_GET,
  payload,
})

export const GET_GROUP_RETAILERS = 'GET_GROUP_RETAILERS'
export const GET_GROUP_RETAILERS_FULFILLED = 'GET_GROUP_RETAILERS_FULFILLED'
export const GET_GROUP_RETAILERS_REJECTED = 'GET_GROUP_RETAILERS_REJECTED'
export const getGroupRetailers = (payload) => ({
  type: GET_GROUP_RETAILERS,
  payload,
})

export const GET_BRAND_RETAILERS = 'GET_BRAND_RETAILERS'
export const GET_BRAND_RETAILERS_FULFILLED = 'GET_BRAND_RETAILERS_FULFILLED'
export const GET_BRAND_RETAILERS_REJECTED = 'GET_BRAND_RETAILERS_REJECTED'
/**
 * @typedef {object} GetBrandRetailersPayload
 * @property {string} id - brand_id
 * @property {string} jwt - jwt auth
 * @property {string[]} fields - fields requested
 * @property {object} filters - retailer filters
 * @property {boolean} adsEnabled - filter by ads enabled
 */
/**
 * Get Brand Retailers
 * @param {GetBrandRetailersPayload} payload
 */
export const getBrandRetailers = (payload) => ({
  type: GET_BRAND_RETAILERS,
  payload,
})

export const GET_FACEBOOK_PAGES = 'GET_FACEBOOK_PAGES'
export const GET_FACEBOOK_PAGES_FULFILLED = 'GET_FACEBOOK_PAGES_FULFILLED'
export const GET_FACEBOOK_PAGES_REJECTED = 'GET_FACEBOOK_PAGES_REJECTED'
/**
 * @typedef {object} GetFacebookPagesPayload
 * @property {string} retailerId - Retailer ID
 */
/**
 * Get Brand Retailers
 * @param {GetFacebookPagesPayload} payload
 */
export const getFacebookPages = (payload) => ({
  type: GET_FACEBOOK_PAGES,
  payload,
})
